import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-slate-900 border-t border-slate-800">
      {/* Tricolor bar */}
      <div className="tricolor-bar" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="p-2 rounded-lg bg-emerald-600/20 border border-emerald-500/30">
                <Shield className="w-5 h-5 text-emerald-400" />
              </div>
              <span className="font-serif text-xl font-semibold text-slate-100">
                Our<span className="text-emerald-400">Neutrality</span>
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed max-w-md">
              A citizen-led campaign at OurNeutrality.ie to protect Ireland's proud tradition of
              Irish neutrality. Make your voice heard—contact your
              representatives today.
            </p>
            <a
              href="mailto:admin@ourneutrality.ie"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 text-sm mt-3 transition-colors"
            >
              admin@ourneutrality.ie
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-slate-100 uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
                >
                  About Neutrality
                </Link>
              </li>
              <li>
                <Link
                  to="/fact-sheet"
                  className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
                >
                  Fact Sheet
                </Link>
              </li>
              <li>
                <Link
                  to="/take-action"
                  className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
                >
                  Take Action
                </Link>
              </li>
              <li>
                <Link
                  to="/resources"
                  className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
                >
                  Resources
                </Link>
              </li>
            </ul>
          </div>

          {/* External Links */}
          <div>
            <h4 className="text-sm font-semibold text-slate-100 uppercase tracking-wider mb-4">
              External Links
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://www.oireachtas.ie"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
                >
                  Houses of the Oireachtas
                </a>
              </li>
              <li>
                <a
                  href="https://www.military.ie"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
                >
                  Defence Forces Ireland
                </a>
              </li>
              <li>
                <a
                  href="https://peacekeeping.un.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-emerald-400 text-sm transition-colors"
                >
                  UN Peacekeeping
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-500">
              © {new Date().getFullYear()} OurNeutrality.ie. All rights
              reserved.
            </p>
            <p className="text-sm text-slate-500">
              Representative data sourced from the{" "}
              <a
                href="https://api.oireachtas.ie"
                target="_blank"
                rel="noopener noreferrer"
                className="text-emerald-400 hover:underline"
              >
                Oireachtas Open Data API
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
